var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useRef } from "react";
import cx from "classnames";
import FocusLock from "react-focus-lock";
import "bootstrap/dist/css/bootstrap.css";
import { styled } from "../styling";
import ReactDOM from "react-dom";
import { ModalTargetContext } from "./ModalTargetContext";
import { Surface } from "../Surface";
const ModalContainer = styled.div.attrs({
    role: "document",
}) `
  height: 100%;
`;
const ModalContent = styled(Surface).attrs({
    elevation: 24,
}) `
  max-width: 100vw;
  max-height: 100vh;
`;
const Wrapper = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  outline: 0;
  z-index: 1050;
  align-items: center;
  justify-content: center;
  display: flex;
`;
const Backdrop = styled.div `
  display: block;
  background-color: ${(props) => props.theme.colors.background};
`;
export const Modal = (props) => {
    const { visible = false, children, autoFocus = false, target: targetProp = React.createRef(), role } = props, divProps = __rest(props, ["visible", "children", "autoFocus", "target", "role"]);
    const defaultTarget = useRef(document.body);
    const contextTarget = useContext(ModalTargetContext);
    const target = targetProp.current
        ? targetProp
        : contextTarget.current
            ? contextTarget
            : defaultTarget;
    return visible
        ? (target.current &&
            ReactDOM.createPortal(React.createElement(React.Fragment, null,
                React.createElement(Backdrop, { className: cx("modal-backdrop", { show: true }) }),
                React.createElement(Wrapper, { className: "modal static-modal", tabIndex: -1, role: "dialog", id: "modal" },
                    React.createElement(FocusLock, { autoFocus: autoFocus },
                        React.createElement(ModalContainer, Object.assign({}, divProps),
                            React.createElement(ModalContent, { elevation: 24, className: "modal-content" }, children))))), target.current)) ||
            null
        : null;
};
//# sourceMappingURL=Modal.js.map